import { createContext, useContext } from 'react';

/**
 * How the host mounts the viewer:
 * - 'view' — read-only. The hosted standalone page
 *   (evidence.lambdatest.com) is ALWAYS view mode.
 * - 'edit' — interactive host (TMS). No component edits anything yet;
 *   future edit-capable components branch on this via useViewerMode()
 *   instead of prop-drilling a flag through the tree.
 */

var ViewerModeContext = /*#__PURE__*/createContext('view');
export var ViewerModeProvider = ViewerModeContext.Provider;
export function useViewerMode() {
  return useContext(ViewerModeContext);
}